module.exports = __webpack_public_path__ + "img/frozen.dd88b74a.svg";